
import { Divider, Grid2, Typography, useTheme } from '@mui/material'
import React, { FC, ReactNode, useEffect } from 'react'
import { Button } from '../../../Form/Button/button.scomponent'
import { GoPlus } from 'react-icons/go'
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import { Input } from '../../../Form/Input/input.component';
import { Control, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup'
import { Checkbox } from '../../../Form/Checkbox/checkbox.component';
import { TProductStoreType } from '../../../../Services/api/products/products.interface';
import { ICategoryEntity } from '../../../../Services/api/categories/categories.interface';
import { IOptionsProps } from '../../../Form/Select/select.component';
  
const SignInSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    code: Yup.string(),
    ncm: Yup.string(),
    personalized: Yup.boolean(),
    createOnNuvemShop: Yup.boolean(),
    createOnOmie: Yup.boolean(),
    price: Yup.string().required('Preço Unitário é obrigatório'),
    description: Yup.string(),
    createOnb2b: Yup.boolean(),
    createOnb2c: Yup.boolean(),
  });
  
interface IDrawerComponent extends DrawerProps {
    onToggle: (state: boolean) => void;
    title: string;
    subTitle?: string;
    search?: boolean;
    searchFunction?: () => void;
    titleStyle?: object
    subTitleStyle?: object
    open: boolean;
    // handleSelect: (category: ICategoryEntity) => void;
    handleSelect: (category: IOptionsProps) => void;
    type: TProductStoreType
    // categories: ICategoryEntity[]
    categories?: IOptionsProps[];
    control: Control<any>
}

const CatetoryListDrawer : FC<IDrawerComponent> = ({ onToggle, title, subTitle, open, titleStyle = {}, subTitleStyle = {}, handleSelect, type, categories, control  }) => {
    const theme = useTheme();
    
    // Valor padrão seguro para evitar erros quando categories ainda não foi carregado
    const safeCategories = categories || [];

    return (
        <Drawer open={open} onClose={onToggle} anchor='right' style={{ zIndex: 99999999 }}>
            <Grid2 sx={{ minWidth: '540px', padding: '30px 30px'}} >
                <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', ...titleStyle}} >{title}</Typography>
                {subTitle && <Typography sx={{ fontSize: '1rem', fontWeight: '400', color: theme.palette.text.secondary,  ...subTitleStyle}} >{subTitle}</Typography> }

                {/* <Grid2 size={12} sx={{ marginTop: '20px'}}>
                    <Input
                        label="Nome"
                        placeholder="Preencha o nome"
                        error={!!errors.name}
                        helperText={errors.name?.message}
                        {...register('name')}
                    />
                </Grid2> */}
        <Grid2 size={12}>
            {/* <Grid2 size={12} sx={{ marginTop: '20px'}}>
                <Button boxLeftSx={{ gap: '10px', marginLeft: '5px'}} style={{  width: '200px'}} LeftIcon={() => <GoPlus size={18} />}>Nova Categoria</Button> 
            </Grid2> */}

            <Divider sx={{ marginTop: '20px', marginBottom:'10px'}} />

            {safeCategories.map((item: IOptionsProps) => (
                <Grid2 size={12} sx={{ marginTop: '20px'}} key={item.value}>
                  <Checkbox label={item.label} name={`switch-${item.value}`} control={control} onChangeCallback={() => handleSelect(item)}/>
                </Grid2>
            ))}

          
        </Grid2>
        </Grid2>
           
           </Drawer>
)
}

export { CatetoryListDrawer }